import { Button } from "components/Button/Button";
import { SelectBox } from "components/Select/Select";
import { trans } from "utils/helpers";
import { ExportDynamicForm } from "../api";
import { useState } from "react";
import { ModalForm } from "components/ModalForm/ModalForm";
import { ImportForm } from "./ImportForm";

interface DefaultSettingPropsType {
    onHide: (e:boolean)=>void;
    handleSettingForm: (e:any)=>void;
    reload: (e:any)=>void;
    obj?:any;
    mode:'create'|'view'|'edit';
}

export const DefaultSetting = ({onHide,reload,handleSettingForm,obj,mode}:DefaultSettingPropsType) => {
const [showImportForm,setShowImportForm]=useState(false)
    const handleSubmit = async(event) => {  
        event.preventDefault()
        let data = {
            "size": event.target.size?.value,
        }
        localStorage.setItem("DefaultSettingFormBuilder" ,JSON.stringify(data))
        handleSettingForm(data)
        onHide(false)    

    }
    const handleExport = async() => {  
        const respons =   await ExportDynamicForm()
        const contentDisposition = respons.headers['file-name'];   
        let fileName = 'downloaded-file'; // Default filename
        if (contentDisposition) {
                fileName = contentDisposition.split('.')[0]
            }
            var pom = document.createElement('a');
            pom.setAttribute('href', window.URL.createObjectURL(respons.data));
            pom.setAttribute('download', fileName);
            pom.click();
            try {
        } catch (error) {
            
        }
    }
    const handleImport = async() => {  
         
setShowImportForm(true)
    }

    function cancel() {
        onHide(false)    
    }

    return ( 
        <>


   {
        showImportForm &&
        <ModalForm modalHeight={80} modalProfileKey={"Users"} title={"import"} onHide={() => setShowImportForm(false)} show={showImportForm}>
          <ImportForm ISPackage={true} reload={()=>{ setShowImportForm(false) ;reload("") }}  showForm={() => { setShowImportForm(false) }} />
        </ModalForm>
      }

              <div className="card legendCard my-3">
        <div className="legend">
         {/* {trans('SendOrReceiveDatasetsAndDataGrids')} */}
         {trans('import')}
       </div>
        <div className="card-body">
{/*         <Button btnType="primary" value="export" onClick={(e)=>{handleExport()}} /> 
 */}        <Button btnType="primary" value="import" onClick={(e)=>{handleImport()}} />
        </div>
       </div>
      <div className="card legendCard my-3">
        <div className="legend">
        {trans("DefaultSetting")}
       </div>
        <form onSubmit={handleSubmit} className="card-body">

                <div className="col-3">
                        <div>
                             <SelectBox
                              lable="dynamicformdefaultfieldsizesetting"
                              selectType="select" 
                              name="size" 
                              
                              value={obj?.size? obj?.size : 12} 
                              val={[2,3,4,6,8,9,10,12]} 
                              options={["15%","25%","33%","50%","66%","75%","85%","100%"]} 
                              mode={mode}
                            />
                        </div>
                    </div>
                    <div className="col-lg-12 mt-1 btns_form">
                        <Button btnType="submit" value="Save" />
                        <Button btnType="cancel" value="cancel" onClick={()=>{cancel()}} />
                    </div>
        </form>
       </div>
        
        </>
     );
}
